import MacromillDesignsystem from './MacromillDesignsystem'

export default MacromillDesignsystem
